import React from 'react';

import styles from './counterListStyles';

import Counter from 'buyside/components/presentation/Counter/counter';

const CounterList = ({ counters = [], type = 'medium' }) => {
  return (
    <div className={styles.flex}>
      {counters.map((counter, idx) => {
        return <Counter key={idx} count={counter.count} title={counter.title} type={type} />;
      })}
    </div>
  );
};

export default CounterList;
